var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgFlutter = function SvgFlutter(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.613 24.075 28.613 0h14.775l-31.35 31.35-7.425-7.275Zm24 23.925h14.775L30.6 35.212l12.788-13.05H28.613l-12.788 12.9L28.613 48Z",
    fill: "#31B1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.6 35.212-7.5-7.5-7.275 7.35 7.275 7.35 7.5-7.2Z",
    fill: "#31B1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.388 48 30.6 35.212l-7.5 7.2L28.613 48h14.775Z",
    fill: "#19599A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23.1 42.412 11.55-3.15-4.05-4.05-7.5 7.2Z",
    fill: "url(#flutter_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flutter_svg__a",
    x1: 22.262,
    y1: 43.635,
    x2: 32.559,
    y2: 37.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#1A5497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195A9B"
  })))));
};

export default SvgFlutter;